import { Experience } from '@cemex-core/cmx-api/models/experiences/experience.model';
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { createReducer, on } from '@ordersnproducts/utils/create-reducer';
import { Action } from '@ngrx/store';
import {
  asyncFailed,
  asyncStart,
  AsyncState,
  asyncSuccess,
  createAsyncState,
} from '@ordersnproducts/utils/create-async-state';
import ExperiencesActions from '../actions/experiences.actions';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface ExperienceEntityState extends EntityState<Experience> {}

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface ExperiencesState extends AsyncState<ExperienceEntityState> {}

export const adapter: EntityAdapter<Experience> = createEntityAdapter<Experience>({
  selectId: (_feature) => _feature.experienceId,
  sortComparer: false,
});

export const initialExperiencesState = createAsyncState({
  ...adapter.getInitialState({}),
});

export const experiencesReducer = createReducer(
  initialExperiencesState,
  on(ExperiencesActions.fetch, asyncStart()),
  on(ExperiencesActions.fetchFailed, asyncFailed()),
  on(
    ExperiencesActions.fetchSuccess,
    asyncSuccess(({ payload }, state) => ({
      payload: {
        ...adapter.setAll(payload, state.payload),
      },
    })),
  ),
  on(ExperiencesActions.resetExperiencesState, (state) => ({
    ...initialExperiencesState,
  })),
);

export function reducer(state: ExperiencesState | undefined, action: Action) {
  return experiencesReducer(state, action);
}
